import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReasoningItemConfig } from "src/app/model/reasoning/ReasoningType";
import { ReasoningComponent } from "../reasoning/reasoning.component";

@Component({
    standalone: true,
    selector: "app-reasoning-group",
    templateUrl: "./reasoning-group.component.html",
    styleUrls: ["./reasoning-group.component.scss"],
    imports: [CommonModule, ReasoningComponent],
})
export class ReasoningGroupComponent {
    @Input() items: ReasoningItemConfig[] = [];
}
